import { Link } from "react-router-dom";
import { useTenant } from "../../../Contexts/TenantContext";
import { PolicyType } from "../../../Enums/PolicyType";
import { InfoBox } from "../../../Components/InfoBox/InfoBox";
import SmartNavbar from "../../../Components/SmartNavbar/SmartNavbar";
import Banner from "../../../Components/Banner/Banner";
import PoliciesLinks from "../../../Components/PoliciesLinks/PoliciesLinks";
import PolicyAccordionItem from "../../../Components/PolicyAccordionItem/PolicyAccordionItem";
import Footer from "../../../Components/Footer/Footer";

const UserPrivacyPoliciesPage = () => {
  const { tenant, tenantContact } = useTenant();

  return (
    <div>
      <SmartNavbar />
      <div className={`w-full bg-gray-50`}>
        <Banner 
          title="Políticas de Privacidade" 
          description={`Prezado Cliente, entendemos que é fundamental explicar de modo transparente nossos processos de tratamento de dados, bem como esclarecer seus direitos como titular destes dados. Esta política se aplica à todas as pessoas que interagem com nossos serviços de comércio na plataforma web e no aplicativo móvel. Lembrando que alguns dados são necessários para a prestação de nossos serviços. Desta forma, caso você não os queira fornecer, poderá optar por não utilizar nossa plataforma. Alguns outros dados não terão o caráter obrigatório, mas a ausência de seu consentimento poderá comprometer a prestação dos nossos serviços a você, como é o caso de recursos terem sua formatação e funcionalidades limitadas em nossa plataforma. ${tenant?.companyName} é o controlador dos dados pessoais tratados em nossa plataforma.`}
        />
        <div className={`w-full flex flex-col md:flex-row gap-4 md:gap-6 page-gutter py-6 xl:px-36`}>
          {/* Mobile policies on top */}
          <div className="flex md:hidden justify-between mb-4">
            <PoliciesLinks excludedPolicy={PolicyType.PrivacyPolicies} isMobile />
          </div>

          {/* Desktop sidebar */}
          <div className={`hidden md:block flex-[0.4] `}>
            <PoliciesLinks excludedPolicy={PolicyType.PrivacyPolicies} />
          </div>

          {/* Accordion items */}
          <div className={`flex flex-col flex-[1.6] gap-4 `}>
            <PolicyAccordionItem
              title="Como coletamos seus dados"
              content={
                <>
                  <div className="text-xs md:text-sm text-gray-800 leading-normal md:text-justify">
                    <p className="mb-2">
                      Nós coletamos seus dados a partir das seguintes fontes:
                    </p>
                    <ul className="list-disc list-inside space-y-2 ml-1">
                      <li>
                        Plataforma E-Commerce {tenant.companyName}: através de seu cadastro na plataforma, coletamos dados de identificação pessoal, dados de identificação eletrônica e dados financeiros. 
                        A totalidade dos dados coletados e seu uso estão descritos na seção <strong>Dados que Coletamos</strong>.
                      </li>
                      <li>
                        Canais de Atendimento: poderemos coletar dados por meio dos canais de atendimento {tenant.companyName}.
                      </li>
                    </ul>
                  </div>
                </>
              }
            />

            <PolicyAccordionItem
              title="Dados que coletamos"
              content={
                <>
                  <div className="text-xs md:text-sm text-gray-800 leading-normal md:text-justify">
                    <p className="mb-5">
                      Durante sua interação com a nossa plataforma e aplicativo, coletamos dados pessoais para poder prestar serviços a você e melhorar sua interação com o nosso e-commerce. Para que possamos vender nossos produtos, alguns dados pessoais são utilizados para cumprimento legal ou regulatório, promoção do nosso negócio através do legítimo interesse, prevenção contra ações ilícitas e fraudes e campanhas de Marketing. Abaixo é possível ver os dados coletados e o propósito do tratamento:
                    </p>
                    <div className="ml-3 mb-5">
                      <div className="mb-5">
                        <h4 className="font-extrabold mb-1">Dados Cadastrais</h4>
                        <p className="mb-3">
                          São dados coletados para realização, confirmação e/ou para alteração de cadastro na plataforma e aplicativo; Estes são utilizados para iniciar a prestação dos nossos serviços e viabilizar a compra e venda de produtos; campanhas de marketing; procedimentos relacionados à emissão de nota fiscal; atendimento de requisitos regulatórios; armazenamento de registros de acesso à plataforma em conformidade com o Marco Civil da Internet; prevenção à fraude na plataforma;
                        </p>

                        <InfoBox title="Pessoa Física (PF)" type="info" className="mb-3">
                          E-mail, número de telefone, nome completo, CPF, RG, data de nascimento, gênero e endereço.
                        </InfoBox>

                        <InfoBox title="Pessoa Jurídica (PJ)" type="info">
                          E-mail, número de telefone, razão social, nome fantasia, CNPJ, inscrição estadual, inscrição municipal, data de fundação e endereço.
                        </InfoBox>
                      </div>
                      <div className="mb-5">
                        <h4 className="font-extrabold mb-1">Dados Financeiros</h4>
                        <p className="mb-3">
                          Procedimentos relacionados à análise e pagamento de produtos vendidos na plataforma da {tenant.companyName}.
                        </p>

                        <InfoBox title="Informações" type="info">
                          Dados bancários para processamento de pagamento, informações de cartão de crédito (nome do titular, número do cartão, data de validade, código verificador, etc.)
                        </InfoBox>
                      </div>
                      <div className="mb-5">
                        <h4 className="font-extrabold mb-1">Dados Computacionais e de navegação</h4>
                        <p className="mb-3">
                          Melhoria da plataforma, como, performance e conteúdo de preferência dos clientes; Armazenamento de registro de acesso; atendimento ao Marco Civil da Internet para possível investigação; prevenção à fraude e outros atos ilícitos à plataforma e-commerce e aplicativo;
                        </p>

                        <InfoBox title="Informações" type="info">
                          Podemos coletar os seguintes dados relacionados ao dispositivo e navegação:
                          <ul className="list-disc list-inside mt-1 space-y-1 ml-1">
                            <li>Endereço IP utilizado na conexão;</li>
                            <li>Tipo de conexão à internet;</li>
                            <li>Localização aproximada do dispositivo pelo endereço IP;</li>
                            <li>Data e hora de acesso;</li>
                            <li>Tipo de dispositivo e identificação do navegador;</li>
                            <li>Tempo de uso no e-commerce e interações (cliques, páginas visualizadas);</li>
                            <li>Informações coletadas via cookies, pixels, tags e rastreadores de terceiros;</li>
                            <li>Modelos de hardware, sistema operacional e versões;</li>
                            <li>Idiomas preferidos e identificadores exclusivos de aparelhos ou publicidade.</li>
                          </ul>
                        </InfoBox>
                      </div>
                      <div className="mb-5">
                        <h4 className="font-extrabold mb-1">Atendimento</h4>
                        <p className="mb-3">
                          Atendimento à requisito regulatório e para proteção da {tenant.companyName} em alguma disputa judicial e análise interna caso haja necessidade, incluindo compartilhamento com seguradoras e empresas de transporte.
                        </p>

                        <InfoBox title="Informações" type="info">
                          Coletamos informações que os clientes enviam quando entram em contato com o atendimento, quando fazem reclamações, avaliações ou elogios, ou entram em contato com a {tenant.companyName} de outra forma, podendo inclusive gravar e ouvir as ligações, Isso pode incluir comentários, fotos ou outros registros, inclusive de terceiros coletados pelos próprios clientes.
                        </InfoBox>
                      </div>
                    </div>
                    <p className="mb-5">
                      De uma forma geral, utilizaremos seus dados para:
                    </p>
                    <p>
                      a) Melhorar a segurança dos nossos clientes e serviços, suporte e atendimento, envio de comunicações (sobre mudanças em nossos termos, políticas ou serviços), créditos e expiração, utilizá-los em procedimentos jurídicos, fornecimento de serviços e recursos, oferecimento, processamento ou facilitação de pagamentos dos nossos produtos;
                    </p>
                    <p>
                      b) Confirmação de cadastro e prevenção e combate à fraude;
                    </p>
                    <p>
                      c) Quando autorizado por você, enviar comunicações de marketing (para divulgação de serviços, produtos, promoções, sorteios, notícias, eventos nossos ou de parceiros).
                    </p>
                  </div>
                </>
              }
            />

            <PolicyAccordionItem
              title="Decisões automatizadas"
              content={
                <>
                  <div className="text-xs md:text-sm text-gray-800 leading-normal md:text-justify">
                    <p>
                      Utilizamos recursos tecnológicos que realizam decisões automatizadas para aumentar a qualidade e a proteção dos nossos serviços. 
                      Esses recursos incluem prevenção contra ações danosas no ambiente tecnológico, gerenciamento de riscos de crédito e combate à fraude a {tenant.companyName} e aos nossos clientes.
                    </p>
                  </div>
                </>
              }
            />

            <PolicyAccordionItem
              title="Compartilhamento de Dados Pessoais"
              content={
                <>
                  <div className="text-xs md:text-sm text-gray-800 leading-normal">
                    <p className="md:text-justify mb-2">
                      Para que possamos prestar nossos serviços com qualidade e atender a legislação vigente, precisamos compartilhar alguns dados pessoais.
                    </p>
                    <p className="md:text-justify mb-2">
                      Compartilhamos seus dados quando aplicável com:
                    </p>              
                    <ul className="list-disc list-inside space-y-2 ml-1">
                      <li>Instituições financeiras, administradoras de cartão de crédito e de pagamentos;</li>
                      <li>Empresas de prevenção à fraude;</li>
                      <li>Empresas de transportes;</li>
                      <li>Instituições Governamentais/autoridades policiais e judiciárias, para atendimento de legislação vigente e demandas judiciais/administrativas. Também incluímos controle fiscal;</li>
                      <li>Parceiros de marketing ou comerciais;</li>
                      <li>Provedores de armazenamento;</li>
                      <li>Consultores, advogados, contadores e outros prestadores de serviços;</li>
                      <li>Mediante consentimento, de maneiras diferentes das listadas nesta política.</li>
                    </ul>
                  </div>
                </>
              }
            />

            <PolicyAccordionItem
              title="Medidas de Segurança"
              content={
                <>
                  <div className="text-xs md:text-sm text-gray-800 leading-normal">
                    <p className="md:text-justify mb-2">
                      A {tenant.companyName} investe continuamente e dispõe de medidas técnicas e administrativas de segurança para proteger seus dados, alinhadas as melhores práticas de segurança da informação. A {tenant.companyName} preza pela Confidencialidade, Integridade e Disponibilidade das informações e dos dados pessoais dos clientes, colaboradores e parceiros de negócios.
                    </p>
                    <p className="md:text-justify mb-2">
                      Há a busca contínua de métodos de proteção contra ações danosas que visam utilizar, acessar, alterar e/ou destruir dados indevidamente, dentre elas, citamos:
                    </p>
                    <ul className="list-disc list-inside space-y-2 ml-1">
                      <li>Controle de acesso físico aos ambientes corporativos;</li>
                      <li>Acesso aos dados somente por profissionais que exercem funções necessárias para atendimento das finalidades específicas;</li>
                      <li>Monitoramento contínuo dos sistemas de informações, de modo a prevenir, detectar e bloquear ações danosas;</li>
                      <li>Armazenamento e transferência de dados utilizando métodos seguros.</li>
                    </ul>
                  </div>
                </>
              }
            />

            <PolicyAccordionItem
              title="Sobre a retenção e eliminação dos dados pessoais"
              content={
                <>
                  <div className="text-xs md:text-sm text-gray-800 leading-normal md:text-justify">
                    <p className="mb-2">
                      De acordo com a legislação vigente, A {tenant.companyName} faz uso dados pelo tempo necessário para atender as finalidades para as quais foram coletados, cumprir com os requerimentos legais aplicáveis e atender ao legítimo interesse da empresa, bem como aos interesses dos titulares dos dados.
                    </p>
                    <p className="mb-2">
                      A pedido do titular, eliminaremos todos os dados pessoais permitidos pela legislação vigente, como sua subscrição a campanhas e notificações de Marketing, eliminação de contas e demais dados pessoais.
                    </p>
                    <p>
                      Apenas manteremos dados pessoais para cumprimento legal ou regulatório, exigências fiscais, seguros, auditorias, contábeis e/ou para proteção da {tenant.companyName}, como prevenção a fraudes e suporte para eventuais demandas judiciais ou administrativas.
                    </p>
                  </div>
                </>
              }
            />

            <PolicyAccordionItem
              title="Seus direitos"
              content={
                <>
                  <div className="text-xs md:text-sm text-gray-800 leading-normal">
                    <p className="md:text-justify mb-2">
                      A {tenant.companyName} visa atender todos os direitos de nossos clientes, conforme definido na Lei, no que tange tratamento de dados pessoais:
                    </p>
                    <ul className="list-disc list-inside space-y-2 ml-1">
                      <li>Confirmar a existência de seus dados;</li>
                      <li>Acessar os dados;</li>
                      <li>Obter informação adicional sobre o uso e compartilhamento de dados;</li>
                      <li>Corrigir os dados;</li>
                      <li>Solicitar a portabilidade dos dados;</li>
                      <li>Revogar o consentimento de algum tratamento de dados;</li>
                      <li>Solicitar a eliminação de dados pessoais, quando possível, conforme previsto nessa política.</li>
                    </ul>
                  </div>
                </>
              }
            />

            <div className="text-xs text-gray-800 leading-normal md:text-justify">
              <p className="mb-5">Estamos sempre à disposição para esclarecer suas dúvidas e colocar você no controle dos seus dados pessoais. Contem conosco para mantê-los informados!</p>
              <p className="mb-5">
                Dúvidas, comentários e reclamações sobre as práticas de tratamento de dados da {tenant?.companyName} podem ser enviados no email 
                <Link
                  to=""
                  className="text-primary-600 ml-1"
                >
                  {tenantContact?.email}
                </Link>.
              </p>
              <p>
                Exerça seus Direitos de Privacidade, entrando em contato conosco por email.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default UserPrivacyPoliciesPage;
